import { render, staticRenderFns } from "./SelectWeekday.vue?vue&type=template&id=0bd98afa&"
import script from "./SelectWeekday.vue?vue&type=script&lang=js&"
export * from "./SelectWeekday.vue?vue&type=script&lang=js&"
import style0 from "./SelectWeekday.vue?vue&type=style&index=0&id=0bd98afa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports